import type { TComponentType } from './types'

/**
 * Ordered list of catalog component types for the page builder preview selector
 * and for AI chat component context selection.
 */
export const CATALOG_PAGE_COMPONENT_TYPES = [
  'chart-bar',
  'chart-radial',
  'tree-navigator',
  'form',
  'vega-lite-chart',
  'table',
  'card',
  'statement-editor',
  'statement-editor-v2',
  'chat',
  'live-chat',
  'data-form',
  'tab-container',
  'md-text',
  'chart-sankey',
  'chart-scatter',
  'chart-heatmap',
  'chart-pie',
  'chart-radar',
  'stepper-component',
  'chart-dumbbell',
  'data-table-v2',
  'chart-line',
  'file-manager',
  'agent-chat',
  'chart-waterfall',
  'triangle',
  'list-cards',
  'word-cloud',
  'chart-diverging-bar',
  'bank-recon',
  'scroll-container',
  'org-chart',
  'chart-icicle',
  'button-actions',
  'financial-statement',
] as const satisfies readonly TComponentType[]
